import sortBy from 'lodash.sortby';

let context = require.context('./', false, /-tool\.js$/);
let modules = context.keys().map(context).map((m) => m.default);
export default sortBy(modules, (m) => m.defaultProps.order);
